// extracted by mini-css-extract-plugin
export default {"contactContainer":"cphlguh8r","contactItemHolder":"cke5a5qwh","icon":"cd3a2d7mc","rightHolder":"cn6i9rqr2","bigText":"cjqd5cadc","smallText":"cvx3jy933"};